var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          attrs: { slot: "activator", outline: "", color: "primary" },
          on: { click: _vm.open },
          slot: "activator"
        },
        [
          _c("v-icon", { attrs: { dark: "", left: "" } }, [_vm._v("note_add")]),
          _vm._v("New Item\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1500px" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("image-uploader", {
                                    attrs: {
                                      constImage: _vm.local.image,
                                      dialog: _vm.dialog,
                                      errorMsg: _vm.errorMsg
                                    },
                                    on: { image: _vm.assignImage }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Name",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "name", $$v)
                                      },
                                      expression: "local.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Type of Dimension")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.local.typeOfDimension,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local,
                                            "typeOfDimension",
                                            $$v
                                          )
                                        },
                                        expression: "local.typeOfDimension"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "3D", value: "3D" }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: { label: "2.5D", value: "2.5D" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Polygon Count",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.polygon_count,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "polygon_count",
                                          $$v
                                        )
                                      },
                                      expression: "local.polygon_count"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Polygon Limitation" },
                                    model: {
                                      value: _vm.local.polygonLimitation,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "polygonLimitation",
                                          $$v
                                        )
                                      },
                                      expression: "local.polygonLimitation"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: { label: "Description" },
                                    model: {
                                      value: _vm.local.description,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "description", $$v)
                                      },
                                      expression: "local.description"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "popover",
                                    {
                                      attrs: {
                                        title:
                                          "Select the type of assets to populate the environment",
                                        always: true
                                      }
                                    },
                                    [_c("h3", [_vm._v("Select Assets")])]
                                  ),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.asset,
                                      "item-text": function(item) {
                                        return item.name
                                      },
                                      "item-value": function(item) {
                                        return item.id
                                      },
                                      label: "Select Assets",
                                      multiple: "",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.selected_assets,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "selected_assets",
                                          $$v
                                        )
                                      },
                                      expression: "local.selected_assets"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("span", [
                                      _vm._v("The number of asset is ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "crimson" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.local.selected_assets.length
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Select Materials")])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.materialsSelect,
                                      "item-text": function(item) {
                                        return item.name
                                      },
                                      "item-value": function(item) {
                                        return item.id
                                      },
                                      label: "Select Materials",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.materials,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "materials", $$v)
                                      },
                                      expression: "local.materials"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Interactive Surfaces")])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.interactiveSurfacesSelect,
                                      "item-text": function(item) {
                                        return item.name
                                      },
                                      "item-value": function(item) {
                                        return item.id
                                      },
                                      label: "Interactive Surfaces",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.interactive_surfaces,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "interactive_surfaces",
                                          $$v
                                        )
                                      },
                                      expression: "local.interactive_surfaces"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "popover",
                                    {
                                      attrs: {
                                        title:
                                          "Background sound for the environment",
                                        always: true
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Allow Sound" },
                                        model: {
                                          value: _vm.allow_sound,
                                          callback: function($$v) {
                                            _vm.allow_sound = $$v
                                          },
                                          expression: "allow_sound"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.allow_sound
                                    ? _c("v-select", {
                                        attrs: {
                                          items: _vm.sounds,
                                          "item-text": function(item) {
                                            return item.name
                                          },
                                          "item-value": function(item) {
                                            return item.id
                                          },
                                          label: "Select Sounds",
                                          multiple: "",
                                          chips: "",
                                          "persistent-hint": ""
                                        },
                                        model: {
                                          value: _vm.local.selected_sounds,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local,
                                              "selected_sounds",
                                              $$v
                                            )
                                          },
                                          expression: "local.selected_sounds"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "popover",
                                    {
                                      attrs: {
                                        title:
                                          "Particle effects attached to the environment",
                                        always: true
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Allow Particle Effects"
                                        },
                                        model: {
                                          value: _vm.local.allow_effect,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.local,
                                              "allow_effect",
                                              $$v
                                            )
                                          },
                                          expression: "local.allow_effect"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "popover",
                                    {
                                      attrs: {
                                        title:
                                          "Dimension of asset in meters(m)",
                                        always: true
                                      }
                                    },
                                    [
                                      _c("h3", [
                                        _vm._v("Asset Dimension(x,y,z)")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension X",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.dimension.X,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.dimension,
                                                  "X",
                                                  $$v
                                                )
                                              },
                                              expression: "local.dimension.X"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Y",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.dimension.Y,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.dimension,
                                                  "Y",
                                                  $$v
                                                )
                                              },
                                              expression: "local.dimension.Y"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Z",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.dimension.Z,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.dimension,
                                                  "Z",
                                                  $$v
                                                )
                                              },
                                              expression: "local.dimension.Z"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Position of Origin")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension X",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.positionOfOrigin.X,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.positionOfOrigin,
                                                  "X",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.positionOfOrigin.X"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Y",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.positionOfOrigin.Y,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.positionOfOrigin,
                                                  "Y",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.positionOfOrigin.Y"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Z",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.positionOfOrigin.Z,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.positionOfOrigin,
                                                  "Z",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.positionOfOrigin.Z"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Rotation of Origin")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension X",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.rotationOfOrigin.X,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.rotationOfOrigin,
                                                  "X",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.rotationOfOrigin.X"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Y",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.rotationOfOrigin.Y,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.rotationOfOrigin,
                                                  "Y",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.rotationOfOrigin.Y"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Z",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.local.rotationOfOrigin.Z,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.rotationOfOrigin,
                                                  "Z",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.rotationOfOrigin.Z"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Scale of Origin")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension X",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.scaleOfOrigin.X,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.scaleOfOrigin,
                                                  "X",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.scaleOfOrigin.X"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Y",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.scaleOfOrigin.Y,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.scaleOfOrigin,
                                                  "Y",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.scaleOfOrigin.Y"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Dimension Z",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.local.scaleOfOrigin.Z,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.scaleOfOrigin,
                                                  "Z",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.scaleOfOrigin.Z"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("h3", [_vm._v("Attachments")]),
                                  _vm._v(" "),
                                  _c(
                                    "file-uploader",
                                    {
                                      on: { input: _vm.assignFBX },
                                      model: {
                                        value: _vm.local.fbx,
                                        callback: function($$v) {
                                          _vm.$set(_vm.local, "fbx", $$v)
                                        },
                                        expression: "local.fbx"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Filmbox",
                                              readonly: "",
                                              "prepend-icon": "attach_file",
                                              rules: _vm.generalRules,
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.local.fbx.fileName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.fbx,
                                                  "fileName",
                                                  $$v
                                                )
                                              },
                                              expression: "local.fbx.fileName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "file-uploader",
                                    {
                                      on: { input: _vm.assignIOS },
                                      model: {
                                        value: _vm.local.asset_bundle.iOS,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local.asset_bundle,
                                            "iOS",
                                            $$v
                                          )
                                        },
                                        expression: "local.asset_bundle.iOS"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "iOS Asset Bundle",
                                              readonly: "",
                                              "prepend-icon": "attach_file",
                                              rules: _vm.generalRules,
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.local.asset_bundle.iOS
                                                  .fileName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.asset_bundle.iOS,
                                                  "fileName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.asset_bundle.iOS.fileName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "file-uploader",
                                    {
                                      on: { input: _vm.assignAndroid },
                                      model: {
                                        value: _vm.local.asset_bundle.Android,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local.asset_bundle,
                                            "Android",
                                            $$v
                                          )
                                        },
                                        expression: "local.asset_bundle.Android"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Android Asset Bundle",
                                              readonly: "",
                                              "prepend-icon": "attach_file",
                                              rules: _vm.generalRules,
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.local.asset_bundle.Android
                                                  .fileName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.local.asset_bundle
                                                    .Android,
                                                  "fileName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "local.asset_bundle.Android.fileName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.save } },
                    [
                      this.saving
                        ? _c(
                            "v-flex",
                            [
                              _c("v-progress-circular", {
                                attrs: { indeterminate: "", color: "primary" }
                              })
                            ],
                            1
                          )
                        : _c("v-flex", [_vm._v("Save")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58eb250a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58eb250a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addEnvironment3D.vue
// module id = null
// module chunks = 